<nb-select [formControl]="control" style="width: 100%;" multiple placeholder="Pages">
    <nb-option *ngFor="let page of Pages" [value]="page.id">{{page.index}}</nb-option>
</nb-select>